<template>
  <div class="chip_container" :class="[size, variant]">
    <component :is="icon" v-if="icon" />
    <div class="div_session_color" v-if="variant === 'session'" />
    <img
      v-if="image && showImage"
      :src="image"
      alt="Chip icon"
      height="14"
      width="14"
      @error="hideImage"
    />
    <label
      class="t-white medium-m white-space-no font-family-2"
      :class="textClass"
      >{{ text }}</label
    >
  </div>
</template>

<script>
import OfflineIcon from "../icons/OfflineIcon.vue";
export default {
  data() {
    return {};
  },
  methods: {
    hideImage(event) {
      this.$nextTick(() => {
        event.target.style.display = "none";
      });
    },
  },
  props: {
    size: {
      type: String,
      default: "small",
    },
    variant: {
      type: String,
      default: "primary",
    },
    text: {
      type: String,
      default: "",
    },
    icon: {
      default: null,
    },
    image: {
      type: String,
      default: "",
    },
    textClass: {
      type: String,
      default: "",
    },
    showImage: {
      default: true,
    },
  },
  components: {
    OfflineIcon,
  },
};
</script>
